import { EventSpace2ActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { DevicesOnline } from '../../types'

/**
 * Event Space 2 Devices Online reducer
 */
const EventSpace2DevicesOnline = buildAsyncStatReducer({
  key: Metrics.EVENTSPACE2_DEVICES_ONLINE,
  types: EventSpace2ActionTypes.DASHBOARD_EVENTSPACE2_DEVICES_ONLINE,
  transform: (state, { payload }): DevicesOnline => {
    const { online, offline }: DevicesOnline = payload || {}
    return { online, offline }
  },
})

export default EventSpace2DevicesOnline
